export enum AssessmentStatusEnum {
    Draft = 0,
    InReview = 1,
    Approved = 2,
    Rejected = 3,
}

export enum RiskRegisterAssessmentStatusEnum {
    Draft = 0,
    Exception = 1,
    Submitted = 2,
    AutoApproved = 3,
    ApprovedWithException = 4,
    Approved = 5,
    Rejected = 6,
}

export enum RiskRegisterAssessmentIconsEnum {
    'assets/images/draft-grey.svg' = RiskRegisterAssessmentStatusEnum.Draft,
    'assets/images/Exception-Status.svg' = RiskRegisterAssessmentStatusEnum.Exception,
    '' = RiskRegisterAssessmentStatusEnum.Submitted,
    'assets/images/auto-approve.svg' = RiskRegisterAssessmentStatusEnum.AutoApproved,
    'assets/images/red-check.svg' = RiskRegisterAssessmentStatusEnum.ApprovedWithException,
    'assets/images/green-check.svg' = RiskRegisterAssessmentStatusEnum.Approved,
    'assets/images/yellow-timer.svg' = RiskRegisterAssessmentStatusEnum.Rejected,
}

export enum RiskRegisterAssessmentColorsEnum {
    '#828282' = RiskRegisterAssessmentStatusEnum.Draft,
    '#E67E22' = RiskRegisterAssessmentStatusEnum.Exception,
    '#60A5FA' = RiskRegisterAssessmentStatusEnum.Submitted,
    '#9B59B6' = RiskRegisterAssessmentStatusEnum.AutoApproved,
    '#E74C3C' = RiskRegisterAssessmentStatusEnum.ApprovedWithException,
    '#01BD79' = RiskRegisterAssessmentStatusEnum.Approved,
    '#F1C40F' = RiskRegisterAssessmentStatusEnum.Rejected,
}

export enum StatisticsEnum {
    methodOfAssessment = 'Method of assessment',
    likelihood = 'Likelihood',
    exposureBand = 'Exposure Band',
    // qualitativeExposureScore = 'Qualitative exposure score',
    // qualitativeFrequencyScore = 'Qualitative frequency score',
    // qualitativeLikelihoodScore = 'Qualitative likelihood score',
    // quantitativeNumberOfSamples = 'Quantitative number of samples',
    quantitativeNumberOfSamples = 'Quantitative number of samples',
    // requiredNumberOfSamples = 'Required number of samples',
    // quantitativeMean = 'Quantitative mean',
    quantitativeGeometricMean = 'Quantitative geometric mean',
    quantitativeGSD = 'Quantitative GSD',
    quantitativeMVUE = 'Quantitative MVUE',
    quantitativeDecisionStatisticValue = 'Quantitative decision statistic value',
    // quantitativeBDA = 'Quantitative BDA',
    quantitativeResultPercentOfOEL = 'Quantitative result percent of OEL',
    quantitativeExceedenceFraction = 'Quantitative exceedence fraction',
    // quantitativeLikelihoodScore = 'Quantitative likelihood score',
}

export enum TableStatisticsEnum {
    methodOfAssessment = 'Method of assessment',
    likelihood = 'Likelihood',
    exposureBand = 'Exposure Band',
    // qualitativeExposureScore = 'Qualitative exposure score',
    // qualitativeFrequencyScore = 'Qualitative frequency score',
    // qualitativeLikelihoodScore = 'Qualitative likelihood score',
    // quantitativeNumberOfSamples = 'Quantitative number of samples',
    quantitativeNumberOfSamples = 'Quantitative number of samples',
    // requiredNumberOfSamples = 'Required number of samples',
    // quantitativeMean = 'Quantitative mean',
    quantitativeGeometricMean = 'Quantitative geometric mean',
    quantitativeGSD = 'Quantitative GSD',
    quantitativeMVUE = 'Quantitative MVUE',
    quantitativeDecisionStatisticValue = 'Quantitative decision statistic value',
    // quantitativeBDA = 'Quantitative BDA',
    quantitativeResultPercentOfOEL = 'Quantitative result percent of OEL',
    quantitativeExceedenceFraction = 'Quantitative exceedence fraction',
    // quantitativeLikelihoodScore = 'Quantitative likelihood score',
}